import React, { useState, useEffect } from 'react';
import { Table, Spin, Button, Row, Col, Dropdown } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { getReceiptListingData, get48HourReceiptListingData } from '../../../../Receipts/ducks/actions.js';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

const antIcon = <LoadingOutlined spin />;

export default (props) => {
  const { currentStep, setCurrentStep, startDate, endDate, reportId, isFor48HourReport } = props;

  const [loading, setLoading] = useState(false);
  const receiptListData = useSelector((state) => state.receipt.receiptListData);
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  useEffect(() => {
    if (isFor48HourReport) {
      dispatch(get48HourReceiptListingData(reportId));
    } else {
      dispatch(getReceiptListingData(startDate, endDate));
    }
  }, [startDate, endDate, isFor48HourReport]);

  //console.log('startDate', startDate, endDate);

  const listColumns = [
    {
      title: 'Date',
      dataIndex: 'date',
      render: (text) => moment(text).format('MM-DD-YYYY'),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
    },
    {
      title: 'Receipt Type',
      dataIndex: 'type',
      render: (text) => <span className="text-capitalize">{text ? text.replace(/_/g, ' ') : '-'}</span>,
    },
    {
      title: 'Contributor',
      dataIndex: 'contributor',
    },
    {
      title: 'Form',
      dataIndex: 'payment_type',
      render: (text) => <span className="text-capitalize">{text ? text.replace(/_/g, ' ') : '-'}</span>,
    },
    {
      title: 'Account Code',
      dataIndex: 'bankaccount',
    },
  ];

  const moveToNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const fetchData = (params = {}, fromDate = 'null', toDate = 'null') => {
    fetch(``).then(({ results }) => {
      setPagination({
        ...params.pagination,
      });
    });
  };

  useEffect(() => {
    fetchData({
      pagination,
    });
  }, []);

  const handleTableChange = (newPagination, filters) => {
    fetchData({
      pagination: newPagination,
      ...filters,
    });
  };

  useEffect(() => {
    setLoading(true);
    if (receiptListData) {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [receiptListData]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Table columns={listColumns} dataSource={receiptListData} pagination={pagination} onChange={handleTableChange} />
      <Row align="middle" justify="center" gutter={[20, 20]}>
        <Col>
          <Button
            type="primary"
            onClick={() => setCurrentStep(currentStep - 1)}
            htmlType="button"
            className="font-gilroy white-btn"
            size="large"
          >
            Back
          </Button>
        </Col>

        <Col>
          <Button
            type="primary"
            onClick={() => moveToNextStep()}
            htmlType="button"
            className="font-gilroy"
            size="large"
          >
            Continue
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};
